import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {AddOutlined, DeleteOutlined, EditOutlined} from '@material-ui/icons';
import ContainedButton from '../../../../shared/buttons/ContainedButton.tsx';
import TabelaProcesso from '../../../components/processo/TabelaProcesso.jsx';
import {ouTraco} from '../../../components/inscricao/documentoInscricao.js';
import {salvarItemNaLista} from '../../../components/processo/processoSelecao.js';
import DialogEnemProcesso from '../../../dialogs/processo/DialogEnemProcesso.jsx';

/* Subaba "Enem" da aba Inscrição (só Ingressante): anos do ENEM permitidos. */
export default function TabInscricaoEnem(props) {
    const {errors, enemsProcesso = [], enems = [], onAlterarLista, onRemover} = props;
    // Índice do ENEM em edição: -1 para adicionar, null com o diálogo fechado.
    const [indiceEnem, setIndiceEnem] = useState(null);

    return (
        <>
            <Grid container spacing={3}>
                <TabelaProcesso
                    nome='enems'
                    errors={errors}
                    linhas={enemsProcesso}
                    semRegistros='Nenhum Enem registrado.'
                    botao={<ContainedButton startIcon={<AddOutlined/>} onClick={() => setIndiceEnem(-1)}>Adicionar</ContainedButton>}
                    colunas={[{label: 'Ano', field: 'ano', valueGetter: valor => ouTraco(valor)}]}
                    acoes={(row, posicao) => [
                        {titulo: 'Editar', icone: <EditOutlined/>, onClick: () => setIndiceEnem(posicao)},
                        {
                            titulo: 'Excluir',
                            icone: <DeleteOutlined/>,
                            onClick: () => onRemover('enems', enemsProcesso, posicao, 'Tem certeza que deseja remover esse Enem?')
                        }
                    ]}/>
            </Grid>
            <DialogEnemProcesso
                open={indiceEnem !== null}
                onClose={() => setIndiceEnem(null)}
                enem={indiceEnem !== null && indiceEnem > -1 ? enemsProcesso[indiceEnem] : null}
                indice={indiceEnem ?? -1}
                enemsProcesso={enemsProcesso}
                enems={enems}
                onSalvar={enem => onAlterarLista('enems', salvarItemNaLista(enemsProcesso, enem, indiceEnem ?? -1))}/>
        </>
    );
}

TabInscricaoEnem.propTypes = {
    errors: PropTypes.object.isRequired,
    /* ENEMs do processo: [{id, idEnem, ano}]. */
    enemsProcesso: PropTypes.array,
    /* ENEMs do apoio: [{id, ano}]. */
    enems: PropTypes.array,
    onAlterarLista: PropTypes.func.isRequired,
    onRemover: PropTypes.func.isRequired
};
